import {
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";
import BottomModal from "components/bottomModal/BottomModal";
import AnimatedCircularLoader from "components/circularLoader/AnimatedCircularLoader";
import React, { FC } from "react";
import styles from "./Reading.module.scss";
import { useTranslation } from "i18n/useTranslation";

interface IReadingProps {
  active: "reading" | "writing" | null;
}

export const Reading: FC<IReadingProps> = ({ active }) => {
  const { resolution } = useScreenStore();
  const { t } = useTranslation();

  return (
    <BottomModal showModal={!!active} hideCloseButton>
      <div className={styles.reading}>
        <div className={styles.warning}>
          {active === "reading" && (
            <h1
              style={{
                fontSize: resolution === ResolutionType.FULL_HD ? 40 : 30,
              }}
            >
              {t("offline_recharge.reading.verifying")}
            </h1>
          )}
          {active === "writing" && (
            <h1
              style={{
                fontSize: resolution === ResolutionType.FULL_HD ? 40 : 30,
              }}
            >
              {t("offline_recharge.reading.writing")}
            </h1>
          )}
          <h1
            style={{
              fontSize: resolution === ResolutionType.FULL_HD ? 40 : 30,
            }}
          >
            {t("offline_recharge.reading.wait")}
          </h1>
        </div>
        <AnimatedCircularLoader
          color="var(--primary)"
          size={250}
          strokeWidth={25}
          initialSeconds={3}
        />
        <div className={styles.info}>
          {active === "reading" && (
            <p
              style={{
                fontSize: resolution === ResolutionType.FULL_HD ? 50 : 35,
              }}
            >
              {t("offline_recharge.reading.do_not_remove")}
            </p>
          )}
        </div>
      </div>
    </BottomModal>
  );
};
